export default "__VITE_ASSET__CzbXu$cy__"